/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { ServiceCreateDto } from '../../models/service-create-dto';
import { ServiceItem } from '../../models/service-item';

export interface ServiceControllerCreate$Params {
      body: ServiceCreateDto
}

export function serviceControllerCreate(http: HttpClient, rootUrl: string, params: ServiceControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: ServiceItem;
}>> {
  const rb = new RequestBuilder(rootUrl, serviceControllerCreate.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: ServiceItem;
      }>;
    })
  );
}

serviceControllerCreate.PATH = '/service';
